import React from 'react'
import PropTypes from 'prop-types'

const SingleImage = ({ singleImage }) => {
  return (
    <div className="container w-100 my-5 text-center">
      <img
        src={singleImage.image.url}
        alt={singleImage.title}
        className="img-fluid"
      />
    </div>
  )
}

export default SingleImage

SingleImage.propTypes = {
  singleImage: PropTypes.object.isRequired
}
